import { ControlTypes } from '@nx-customer-apps/shared/enums';
import { StepperOptions } from '@nx-customer-apps/shared/interfaces';
import { QuestionBase } from './question-base.model';
import { Mask } from '@nx-customer-apps/components';

export class StepperQuestion extends QuestionBase<number> {
    override controlType = ControlTypes.Stepper;
    public min: number;
    public max: number;
    public step: number;
    public mask?: Mask;
    constructor(options: StepperOptions) {
        super(options);
        this.min = options.min ?? 0;
        this.max = options.max ?? 99;
        this.step = options.step ?? 1;
        this.mask = options.mask;
        this.value = options.value ?? this.min;
    }
}
